import Web3 from 'web3';

const web3 = new Web3(window.ethereum);

export const blockchainURL = 'https://a0mbapghx9-a0qccpugrh-rpc.au0-aws.kaleido.io/';

export const username = 'a0kxwspf7q';

export const password = 'rubPSmfS1FxZPHqfF4KtH5u7Sj3H27AmmWLxZLFWVIY';

export const contractAddress = '0x7e3d04143f64f28c34b386b738a593d88970926f';

export const contractAbi = [
  {
    "inputs": [],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      }
    ],
    "name": "DistributorVCUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      }
    ],
    "name": "FarmerVCUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      }
    ],
    "name": "InspectorVCUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "enum SupplyChain.ProcessStatus",
        "name": "status",
        "type": "uint8"
      }
    ],
    "name": "ProcessStatusUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      }
    ],
    "name": "RetailerVCUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "user",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "enum SupplyChain.UserRole",
        "name": "role",
        "type": "uint8"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "name",
        "type": "string"
      }
    ],
    "name": "RoleRegistered",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "user",
        "type": "address"
      }
    ],
    "name": "RoleRevoked",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "batchStatus",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "quantity",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "gradingResults",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "countryOfOrigin",
        "type": "string"
      }
    ],
    "name": "createFarmerVC",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "currentBatchID",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "distributorVCs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "distributorAddress",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "acceptance",
        "type": "bool"
      },
      {
        "internalType": "string",
        "name": "remark",
        "type": "string"
      },
      {
        "internalType": "uint256",
        "name": "timestamp",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "farmerVCs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "dateOfProduction",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "quantity",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "expiryDate",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "gradingResults",
        "type": "string"
      },
      {
        "internalType": "address",
        "name": "farmerAddress",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "timestamp",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "countryOfOrigin",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      }
    ],
    "name": "getDistributorVCByBatchId",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "batchID",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "distributorAddress",
            "type": "address"
          },
          {
            "internalType": "bool",
            "name": "acceptance",
            "type": "bool"
          },
          {
            "internalType": "string",
            "name": "remark",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          }
        ],
        "internalType": "struct SupplyChain.DistributorVC",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      }
    ],
    "name": "getFarmerVCByBatchId",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "batchID",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "dateOfProduction",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "quantity",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "expiryDate",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "gradingResults",
            "type": "string"
          },
          {
            "internalType": "address",
            "name": "farmerAddress",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "countryOfOrigin",
            "type": "string"
          }
        ],
        "internalType": "struct SupplyChain.FarmerVC",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getInfectedBatchIDs",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      }
    ],
    "name": "getInspectorVCByBatchId",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "batchID",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "inspectorCheck",
            "type": "bool"
          },
          {
            "internalType": "address",
            "name": "inspectorAddress",
            "type": "address"
          },
          {
            "internalType": "string",
            "name": "remark",
            "type": "string"
          },
          {
            "internalType": "bool",
            "name": "dangerCheck",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          }
        ],
        "internalType": "struct SupplyChain.InspectorVC",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      }
    ],
    "name": "getRetailerVCByBatchId",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "batchID",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "stockingInfo",
            "type": "string"
          },
          {
            "internalType": "address",
            "name": "retailerAddress",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "timestamp",
            "type": "uint256"
          }
        ],
        "internalType": "struct SupplyChain.RetailerVC",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTotalDistributorVCs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTotalFarmerVCs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTotalInfectedBatches",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTotalInspectorVCs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getTotalRetailerVCs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "index",
        "type": "uint256"
      }
    ],
    "name": "getUserAddressByIndex",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getUserCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "user",
        "type": "address"
      }
    ],
    "name": "getUserRoles",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "enum SupplyChain.UserRole",
        "name": "",
        "type": "uint8"
      },
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "inspectorVCs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "inspectorCheck",
        "type": "bool"
      },
      {
        "internalType": "address",
        "name": "inspectorAddress",
        "type": "address"
      },
      {
        "internalType": "string",
        "name": "remark",
        "type": "string"
      },
      {
        "internalType": "bool",
        "name": "dangerCheck",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "timestamp",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "processStatus",
    "outputs": [
      {
        "internalType": "enum SupplyChain.ProcessStatus",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "user",
        "type": "address"
      },
      {
        "internalType": "enum SupplyChain.UserRole",
        "name": "role",
        "type": "uint8"
      },
      {
        "internalType": "string",
        "name": "name",
        "type": "string"
      }
    ],
    "name": "registerUserRole",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "remark",
        "type": "string"
      },
      {
        "internalType": "bool",
        "name": "dangerCheck",
        "type": "bool"
      },
      {
        "internalType": "bool",
        "name": "approval",
        "type": "bool"
      }
    ],
    "name": "reportHealthIssues",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "retailerVCs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "stockingInfo",
        "type": "string"
      },
      {
        "internalType": "address",
        "name": "retailerAddress",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "timestamp",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "user",
        "type": "address"
      }
    ],
    "name": "revokeUserRole",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "acceptance",
        "type": "bool"
      },
      {
        "internalType": "string",
        "name": "remark",
        "type": "string"
      }
    ],
    "name": "updateDistributorVC",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      },
      {
        "internalType": "bool",
        "name": "inspectorCheck",
        "type": "bool"
      },
      {
        "internalType": "string",
        "name": "remark",
        "type": "string"
      },
      {
        "internalType": "bool",
        "name": "dangerCheck",
        "type": "bool"
      }
    ],
    "name": "updateInspectorVC",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "batchID",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "stockingInfo",
        "type": "string"
      }
    ],
    "name": "updateRetailerVC",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "userAddresses",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "userCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "userNames",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "userRoles",
    "outputs": [
      {
        "internalType": "enum SupplyChain.UserRole",
        "name": "",
        "type": "uint8"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];

const SupplyChainContract = new web3.eth.Contract(contractAbi, contractAddress);

export default SupplyChainContract;



// NEW APP CRED
